import React, { useCallback, useMemo } from 'react';
import './CallControls.css';
import Button from '../../primitives/Button/Button';

import { ReactComponent as MicOffIcon } from '../../../../assets/icon/mic-off.svg';
import { ReactComponent as CameraOffIcon } from '../../../../assets/icon/camera-off.svg';
import { ReactComponent as CameraOnIcon } from '../../../../assets/icon/camera-on.svg';
import { ReactComponent as LeaveIcon } from '../../../../assets/icon/call-end.svg';
import LocalDailyMic from '../../Mic/LocalDailyMic';
import { useCallLocalMedia, CallLocalMediaContextValue } from '../../context/CallLocalMediaContext';
import { useNavigate } from 'react-router-dom';
import { useDaily } from '@daily-co/daily-react';
import UserMediaService from '../../../../services/UserMediaService';

interface CallControlsProps {
}

const HUDCallControls: React.FC<CallControlsProps> = ({ }) => {
  const { isMicEnabled, isCameraEnabled, handleEnableMic, handleEnableCamera } = useCallLocalMedia() as CallLocalMediaContextValue;
  const navigate = useNavigate();
  const callObject = useDaily();

  const toggleMic = useCallback(async () => {
    await handleEnableMic(!isMicEnabled);
  }, [isMicEnabled, handleEnableMic]);

  const toggleCamera = useCallback(async () => {
    await handleEnableCamera(!isCameraEnabled);
  }, [isCameraEnabled, handleEnableCamera]);

  const handleLeaveRoom = useCallback(async () => {
    await callObject?.leave();
    await callObject?.destroy();
    UserMediaService.stopMediaTracks();
    navigate('/');
  }, [callObject, navigate]);

  const toggleMicButton = useMemo(() => (
    <Button onClick={toggleMic} icon={isMicEnabled ? <LocalDailyMic /> : <MicOffIcon />} size={'small'} />
  ), [toggleMic, isMicEnabled]);

  const toggleCameraButton = useMemo(() => (
    <Button onClick={toggleCamera} icon={isCameraEnabled ? <CameraOnIcon /> : <CameraOffIcon />}  size={'small'} />
  ), [toggleCamera, isCameraEnabled]);

  const leaveRoomButton = useMemo(() => (
    <Button onClick={handleLeaveRoom} icon={<LeaveIcon />}  size={'small'} />
  ), [handleLeaveRoom]);

  return (
    <div className='callcontrols-container'>
      { toggleMicButton }
      { toggleCameraButton }
      { leaveRoomButton }
    </div>
  );
};

export default HUDCallControls;
